var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTableRow',{staticClass:"loading-row"},[_c('BaseTableCell',{staticClass:"loader-cell",attrs:{"colspan":"8"}},[_c('BaseLoaderCircular',{staticClass:"row-loader"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }